import React from 'react';
import { Link } from "react-router-dom"
import { useLocation } from "react-router-dom";

const NavBarLink = (props) => {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  return (
    <>
    <li className="nav-item fs-ss-links text-ss-secondary me-lg-3">
    <Link className={splitLocation[1] === `${props.Link_To}` ? `nav-link hover-ss-primary text-ss-primary fw-500 ${props.Border}` : `nav-link hover-ss-primary text-ss-secondary fw-500 ${props.Border}`} to={`/${props.Link_To}`}> {props.Name} </Link>
    </li>
    </>
  )
}

export default NavBarLink